export var TypeActionLimitedActionInfo;
(function (TypeActionLimitedActionInfo) {
    TypeActionLimitedActionInfo["Received"] = "LimitedActionInfo > Received";
    TypeActionLimitedActionInfo["Update"] = "LimitedAction > Update";
})(TypeActionLimitedActionInfo || (TypeActionLimitedActionInfo = {}));
export var actionLimitedActionInfoReceived = function (limitedAction) { return ({
    limitedAction: limitedAction,
    type: TypeActionLimitedActionInfo.Received,
}); };
export var actionLimitedActionInfoFetch = function () { return ({
    type: TypeActionLimitedActionInfo.Update,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/limited-action-info/actionLimitedActionInfo.ts
// module id = 346
// module chunks = 3